import { useMutation, useQueryClient } from "@tanstack/react-query";
import { operations } from "../openapi/generated-types.ts";
import { cancel } from "../openapi/api-client.ts";

export const useCancel = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (
      body: operations["registration.write.cancel"]["requestBody"]["content"]["application/json"],
    ) => {
      return cancel(body, {});
    },
    onSettled: async () => {
      await Promise.all([
        queryClient.invalidateQueries({
          queryKey: ["events"],
        }),
      ]);
    },
  });
};
